import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class NpsByDeviceBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const npsByDevice = answersReport ? answersReport.npsByDevice : [];

    const categories = npsByDevice.map(item => item.device);
    const data = npsByDevice.map(item => item.nps);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: {
        text: intl.formatMessage({id: 'nps'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: npsByDevice[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(NpsByDeviceBarChart),
  graphql`
    fragment NpsByDeviceBarChart_answersReport on AnswersReport {
      npsByDevice {
        device
        nps
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/NpsByDeviceBarChart/NpsByDeviceBarChart.js